import React from 'react';
import EditIcon from 'components/pure/utils/icon/EditIcon';
import {TrendType} from 'records/TriggerTrend';
import './TriggerTrendView.styl';

const {AVERAGE_OF_TIMES} = TrendType;

export default class TriggerTrendView extends React.Component {
  render() {
    const {editTrend, trend, readonly} = this.props;
    const {trendType} = trend;
    return (
      <div className="triggers-trend-view trigger-container">
        <header>
          <div className="info">
            <div className="title">Trend</div>
            <div className="description">How often the event occurs</div>
          </div>
          {!readonly && (
            <div className="trigger-edit-icon" onClick={editTrend}>
              <EditIcon />
            </div>
          )}
        </header>
        <div className="trigger-actions-content trigger-content">
          When the {trendType === AVERAGE_OF_TIMES ? 'average ' : ' '}
          number of times that this happens:
          <ul>
            {trendType === AVERAGE_OF_TIMES && (
              <li>per {trend.getSubPeriodText().toLowerCase()}</li>
            )}
            <li>over {trend.getPeriodText()}</li>
            <li>is {trend.getThresholdText().toLowerCase()}</li>
          </ul>
        </div>
      </div>
    );
  }
}
